<template>
  <keep-alive>
    <b-modal
      :no-close-on-backdrop="true"
      id="addTag"
      size="sm"
      ref="addTag"
      body-class="bg-white"
      @hidden="$emit('setMultipleAddedRef', {
        close : true
      })"
      cancel-title="Close"
      cancel-variant="light"
      :ok-title-html="tag_id.tag_id != '' ? submitted==true?loaderIcon+'Update':'Update' : submitted==true?loaderIcon+'Save':'Save'"
      :title="tag_id.tag_id != '' ? 'Edit Tag' : 'Add Tag'"
      @ok="handleOk"
      :ok-disabled="submitted"
      @shown="tag.tag_name = tag_id.tag_name"
    >
      <b-form @submit.stop.prevent="addtag_form" id="addtag_form">
        <b-form-group>
          <b-row>
            <b-col lg="12">
              <label for="tag_name" class="required">Tag Name</label>
              <b-form-input
                v-validate="'required|max:100'"
                id="tag_name"
                type="text"
                v-model.trim="tag.tag_name"
                name="tag_name"
                data-vv-name="tag name"
                placeholder
              />
              <input type="hidden" name="tag_id" :value="tag_id.tag_id" />
              <span class="text-danger" v-if="errors.has('tag name')">{{ errors.first('tag name') }}</span>
            </b-col>
          </b-row>
        </b-form-group>
      </b-form>
    </b-modal>
  </keep-alive>
</template>
<script>
import store from "@/store/index";
import { notificationMixin } from "@/mixins/notification";

export default {
  mixins: [notificationMixin],
  props: ["tag_id", "module", "tagmodal"],
  data() {
    return {
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      tag: {
        tag_name: "",
      },
    };
  },

  methods: {
    handleOk(evt) {
      // Prevent modal from closing
      evt.preventDefault();
      if (this.tag.tag_name == "" || this.tag.tag_name.length > 100) {
        var message =
          this.tag.tag_name == ""
            ? "Tag name should not be empty"
            : "Tag name(100) exceeds maximum length";
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: message,
          type: "danger",
          showCloseButton: true,
        });
      } else {
        this.submitted = true;
        let myForm = document.getElementById("addtag_form");
        let formData = new FormData(myForm);
        var url = this.module + "/addTag";
        store.dispatch(url, formData).then((response) => {
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: response.data.status,
            type: response.status == 200 ? "success" : "danger",
            showCloseButton: true,
          });
          this.submitted = false;
          if (response.status == 200) {
              this.$emit("setMultipleAddedRef", this.tag);
            this.$refs.addTag.hide();
            
          }
         
        });
      }
    },
  },
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air",
    };
  },
};
</script>
<style>
.required:after {
  color: #e32;
  content: " *";
  display: inline;
}
</style>